import React from "react";
import { useTranslation } from "react-i18next";
import OptimizedImage from "../components/image-optimization/OptimizedImage";
import StarRating from "../components/StarRating";

const TestimonialItem: React.FC<{
  name: string;
  rating: string;
  comment: string;
  date: string;
}> = ({ name, rating, comment, date }) => {
  return (
    <div className="item">
      <span className="quote">
        <OptimizedImage src="images/quot.png" alt="" />
      </span>
      <p>{comment}</p>
      <div className="info">
        <div className="author-img">
          <OptimizedImage src="images/logos/tripadvisor.png" alt="" />
        </div>
        <div className="cont">
          <span>
            <StarRating rating={rating} />
          </span>
          <h6>{name}</h6> <span>{date}</span>
        </div>
      </div>
    </div>
  );
};

const TestimonialsSection: React.FC = () => {
  const { t: tHome } = useTranslation("home");
  
  return (
    <section className="testimonials">
      <div
        className="background bg-img bg-fixed section-padding pb-0"
        data-background="images/slider/2.jpg"
        data-overlay-dark="6"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="testimonials-box">
                <div className="head-box">
                  <h6>{tHome("testimonials.subtitle")}</h6>
                  <h4>{tHome("testimonials.title")}</h4>
                  <div className="line"></div>
                </div>
                <div className="owl-carousel owl-theme">
                  <TestimonialItem
                    name={tHome("testimonials.item1.name")}
                    rating={tHome("testimonials.item1.rating")}
                    date={tHome("testimonials.item1.date")}
                    comment={tHome("testimonials.item1.comment")}
                  />
                  <TestimonialItem
                    name={tHome("testimonials.item2.name")}
                    rating={tHome("testimonials.item2.rating")}
                    date={tHome("testimonials.item2.date")}
                    comment={tHome("testimonials.item2.comment")}
                  />
                  <TestimonialItem
                    name={tHome("testimonials.item3.name")}
                    rating={tHome("testimonials.item3.rating")}
                    date={tHome("testimonials.item3.date")}
                    comment={tHome("testimonials.item3.comment")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
